import {Component, Prop, Vue} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";

@Component
export class Modal extends Vue {

  @Prop({type: Boolean, default:false}) isActive: boolean;

  render(){
    return (
      <div class={className("modal", {isActive: this.isActive})}>
        <div class="modal-background" />

        <div class="modal-content">
          {this.$slots.default}
        </div>

        <button class="modal-close is-large" aria-label="close" onClick={() => this.$emit("close")}/>

      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-228852b7/modal.tsx" });